import { AppProviders } from './providers';

export function App() {
  return <AppProviders />;
}
